module.exports = __webpack_public_path__ + "20cb89e86f5dc6e6b53465980d9791b5.svg";